import React, { createContext, useContext } from 'react';
import { useSnackbar, VariantType } from 'notistack';

interface ToastContextType {
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
}

const ToastContext = createContext<ToastContextType | null>(null);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();

  const showToast = (message: string, variant: VariantType) => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
      autoHideDuration: variant === 'error' ? 6000 : 4000,
    });
  };

  return (
    <ToastContext.Provider value={{
      showSuccess: (msg) => showToast(msg, 'success'),
      showError: (msg) => showToast(msg, 'error'),
      showWarning: (msg) => showToast(msg, 'warning'),
      showInfo: (msg) => showToast(msg, 'info'),
    }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};
